import { ApiError } from "./ApiError";
import { getAuthHeaders } from "./api";

const API_BASE_URL =
    import.meta.env.VITE_API_BASE_URL || "https://stg-native-api.cleverpe.com/api";


// =========================================================
// SEND EMAIL OTP
// =========================================================

export interface SendEmailOTPResponse {
    success: boolean;

    data: {
        message: string;
        otpHash: string;
    };
}

export const sendEmailOTP = async (
    email: string
): Promise<SendEmailOTPResponse> => {

    const token =
        localStorage.getItem("journey_token");

    if (!token) {
        throw new ApiError(
            "Journey session expired.",
            401
        );
    }

    const response = await fetch(
        `${API_BASE_URL}/journey/email/send-otp`,
        {
            method: "POST",

            headers: {
                ...getAuthHeaders(),
                "Content-Type": "application/json",
            },

            body: JSON.stringify({
                email,
            }),
        }
    );

    const data = await response.json();

    if (!response.ok) {
        throw new ApiError(
            data?.message ||
            data?.data?.message ||
            "Unable to send email OTP.",
            response.status,
            data
        );
    }

    return data;
};


// =========================================================
// VERIFY EMAIL OTP
// =========================================================

export interface VerifyEmailOTPRequest {
    email: string;
    otp: string;
    otpHash: string;
}

export interface VerifyEmailOTPResponse {
    success: boolean;

    data: {
        message: string;
        email: string;
        emailVerified: boolean;
    };
}

export const verifyEmailOTP = async (
    request: VerifyEmailOTPRequest
): Promise<VerifyEmailOTPResponse> => {

    const token =
        localStorage.getItem("journey_token");

    if (!token) {
        throw new ApiError(
            "Journey session expired.",
            401
        );
    }

    const response = await fetch(
        `${API_BASE_URL}/journey/email/verify-otp`,
        {
            method: "POST",

            headers: {
                ...getAuthHeaders(),
                "Content-Type": "application/json",
            },

            body: JSON.stringify(request),
        }
    );

    const data = await response.json();

    if (!response.ok) {
        throw new ApiError(
            data?.message ||
            data?.data?.message ||
            "Unable to verify email OTP.",
            response.status,
            data
        );
    }

    return data;
};

// =========================================================
// VERIFY GOOGLE EMAIL
// =========================================================

export interface VerifyGoogleEmailRequest {
    idToken: string;
}

export interface VerifyGoogleEmailResponse {
    success: boolean;

    data: {
        message: string;
        email: string;
        emailVerified: boolean;
    };
}

export const verifyGoogleEmail = async (
    idToken: string
): Promise<VerifyGoogleEmailResponse> => {

    const token =
        localStorage.getItem("journey_token");

    if (!token) {
        throw new ApiError(
            "Journey session expired.",
            401
        );
    }

    const response = await fetch(
        `${API_BASE_URL}/journey/email/google-verify`,
        {
            method: "POST",

            headers: {
                ...getAuthHeaders(),
                "Content-Type": "application/json",
            },

            body: JSON.stringify({
                idToken,
            }),
        }
    );

    const data = await response.json();

    if (!response.ok) {
        throw new ApiError(
            data?.message ||
            data?.data?.message ||
            "Unable to verify Google account.",
            response.status,
            data
        );
    }

    return data;
};